import { render } from "./WhatsappAction.vue?vue&type=template&id=fdc11c78&scoped=true"
import script from "./WhatsappAction.vue?vue&type=script&lang=js"
export * from "./WhatsappAction.vue?vue&type=script&lang=js"

import "./WhatsappAction.vue?vue&type=style&index=0&id=fdc11c78&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdc11c78"]])

export default __exports__